module.exports = __webpack_public_path__ + "img/img-risk.195acf6d.jpg";